import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import { userDate, formatYearMonth } from 'owa-datetime';
import type { MailHeaderProps } from '../schema';

import * as styles from './styles.scss';

export interface MailSearchHeaderProps {
    item: SearchResultItem;
}

export default observer(function MailSearchHeader(props: MailSearchHeaderProps) {
    const { item } = props;
    const data = item.data as MailHeaderProps;

    const date = userDate(data.DateTimeReceived || '');
    const text = data.headerText ? data.headerText : formatYearMonth(date);

    return <div className={styles.mailSearchHeader}>{text}</div>;
});
